import { ConnectionAuthType } from './connection-auth-types.model';
import { ConnectionType } from './connection-types.model';

export interface GetConnectionResponse {
    connection: ConnectionInfo;
    businessDomain: BusinessDomainInfo;
}

export enum ConnectionState {
    Pending = 'Pending',
    Active = 'Active',
    Failed = 'Failed',
}

export interface ConnectionInfo {
    id: string;
    type: ConnectionType;
    authType: ConnectionAuthType;
    alias: string;
    host: string;
    username: string;
    port: number;
    sourceName: string;
    isPushdown: boolean;
    roles: string[];
    // agent: Agent
    secret: SecretInfo | null;
    requestAccessURL: string | null;
    state: ConnectionState;
    stateMessage: string | null;
}

interface SecretInfo {
    id: string;
    clientId: string;
    displayName: string;
    createdBy: string;
    createdAt: string;
    expiresAt: string | null;
    isExpired: boolean;
    state: string;
}

interface BusinessDomainInfo {
    id: string;
    name: string;
    servicePrincipal: ServicePrincipalInfo | null;
}

interface ServicePrincipalInfo {
    id: string;
    name: string;
    servicePrincipalId: string;
    appRegistrationId: string;
    createdBy: string;
    createdAt: string;
}
